export default __webpack_public_path__ + "static/media/pulseox.135a3fb2.png";